<template>
	<div class="ms-header">
		<v-toolbar flat color="primary" height="60px">
			<v-toolbar-title class="subheading white--text">
				{{ memberName }} 様 <br>
				{{ textDate }}
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<Menu @show-edit-member-self="$emit('show-edit-member-self')" />
		</v-toolbar>
	</div>
</template>

<script>
import Menu from './Menu';

const strftime = require('strftime');
export default {
	name: 'MSHeader',
	props: ["member", "date"],
	components: {
		Menu,
	},
	computed: {
		textDate: function() {
			return strftime('～ %Y年%m月%d日', this.date);
		},
		memberName: function() {
			if(this.member) 
				return this.member.name;
			if(this.$store.getters.accessToken)
				return this.$store.getters.memberList.find(m => m.code === this.$store.getters.accessToken.sub).name;
			return '';
		},
	},
}
</script>
<style>
	.ms-header{
		position :fixed;
		top: 0;
		width: 100%;
		z-index: 102;
	}
</style>
